export const PRODUCT_STATUSES = [
  "In Warehouse",
  "Reserved",
  "Ready to Ship",
  "Packed",
  "Shipped",
  "Delivered",
  "Installed",
  "Returned",
  "Damaged",
  "Missing",
];

export const CRATE_STATUSES = [
  "Empty in Warehouse",
  "In Warehouse with DSK",
  "Packed with Product",
  "In Transit to Store",
  "Delivered to Store",
  "Waiting for Return",
  "In Transit Back to Warehouse",
  "Returned to Warehouse",
  "Damaged",
  "Missing",
];

export const SHIPMENT_STATUSES = [
  "Created",
  "Packed",
  "Shipped",
  "Delivered",
  "Installed",
  "Waiting for Box Return",
  "Box Return In Transit",
  "Box Returned",
  "Closed",
  "Issue / Exception",
];

export const USER_ROLES = ["admin", "warehouse_staff", "client_user"];

export const ROLE_LABELS = {
  admin: "Admin",
  warehouse_staff: "Warehouse Staff",
  client_user: "Organization User",
};

export const CARRIERS = ["UPS", "FedEx", "USPS", "Freight", "Other"];

export const WAREHOUSE = "Dolphin Warehouse — Carrollton, TX";
